export const featuredBanners = [
  {
    id: 1,
    title: '《流浪地球3》震撼来袭',
    subtitle: '国产科幻巨制，视觉盛宴不容错过',
    image: 'https://readdy.ai/api/search-image?query=epic%20cinematic%20sci-fi%20scene%20with%20futuristic%20spaceship%20and%20warm%20orange%20sunset%20atmosphere%2C%20dramatic%20lighting%2C%20movie%20poster%20style%2C%20Chinese%20science%20fiction%20film%20aesthetic%2C%20grand%20scale%20composition%2C%20deep%20space%20and%20earth%20background&width=1600&height=700&seq=hero-banner-01&orientation=landscape',
    link: '/article/1',
    tag: '热映中',
  },
  {
    id: 2,
    title: '《庆余年3》全网首播',
    subtitle: '权谋大剧回归，精彩剧情再升级',
    image: 'https://readdy.ai/api/search-image?query=ancient%20Chinese%20palace%20drama%20cinematic%20scene%20with%20traditional%20architecture%20and%20warm%20golden%20light%2C%20historical%20costume%20drama%20aesthetic%2C%20epic%20scale%20with%20mist%20and%20atmosphere%2C%20film%20poster%20style%20composition&width=1600&height=700&seq=hero-banner-02&orientation=landscape',
    link: '/article/2',
    tag: '热播剧',
  },
  {
    id: 3,
    title: '《乘风2026》综艺热播',
    subtitle: '姐姐们再次集结，舞台燃爆全场',
    image: 'https://readdy.ai/api/search-image?query=vibrant%20stage%20performance%20with%20colorful%20stage%20lights%20and%20dynamic%20atmosphere%2C%20variety%20show%20style%2C%20entertainment%20show%20aesthetic%2C%20grand%20music%20stage%20with%20warm%20spotlight%20effects%2C%20energetic%20composition&width=1600&height=700&seq=hero-banner-03&orientation=landscape',
    link: '/article/3',
    tag: '热门综艺',
  },
];

export const categories = [
  { id: 'movie', name: '电影', icon: 'ri-film-line', count: 2856, color: 'primary' },
  { id: 'tv', name: '电视剧', icon: 'ri-tv-line', count: 3421, color: 'accent' },
  { id: 'variety', name: '综艺', icon: 'ri-music-2-line', count: 1528, color: 'secondary' },
  { id: 'anime', name: '动漫', icon: 'ri-rocket-line', count: 2134, color: 'primary' },
  { id: 'documentary', name: '纪录片', icon: 'ri-global-line', count: 876, color: 'accent' },
  { id: 'kids', name: '少儿', icon: 'ri-star-smile-line', count: 654, color: 'secondary' },
];

export const hotRecommendations = [
  {
    id: 1,
    title: '流浪地球3',
    category: '电影',
    rating: 9.2,
    image: 'https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20style%2C%20futuristic%20sci-fi%20astronaut%20in%20space%20with%20earth%20in%20background%2C%20dramatic%20orange%20and%20blue%20lighting%2C%20film%20poster%20composition%2C%20clean%20dark%20background&width=600&height=800&seq=hot-rec-01&orientation=portrait',
    tag: '热映',
  },
  {
    id: 2,
    title: '庆余年3',
    category: '电视剧',
    rating: 9.5,
    image: 'https://readdy.ai/api/search-image?query=ancient%20Chinese%20costume%20drama%20poster%20style%2C%20elegant%20figure%20in%20traditional%20robes%20with%20palace%20background%2C%20warm%20golden%20lighting%2C%20historical%20drama%20aesthetic%2C%20clean%20composition&width=600&height=800&seq=hot-rec-02&orientation=portrait',
    tag: '热播',
  },
  {
    id: 3,
    title: '长安十二时辰2',
    category: '电视剧',
    rating: 8.9,
    image: 'https://readdy.ai/api/search-image?query=historical%20Chinese%20drama%20poster%2C%20Tang%20Dynasty%20warrior%20in%20armor%20with%20ancient%20city%20background%2C%20dramatic%20cinematic%20lighting%2C%20epic%20film%20poster%20style%2C%20warm%20amber%20tones&width=600&height=800&seq=hot-rec-03&orientation=portrait',
    tag: '推荐',
  },
  {
    id: 4,
    title: '封神第二部',
    category: '电影',
    rating: 8.7,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20mythological%20fantasy%20film%20poster%2C%20ancient%20Chinese%20god%20with%20magical%20elements%2C%20dramatic%20lighting%20with%20golden%20and%20red%20tones%2C%20epic%20cinematic%20composition%2C%20clean%20dark%20background&width=600&height=800&seq=hot-rec-04&orientation=portrait',
    tag: '热映',
  },
  {
    id: 5,
    title: '乘风2026',
    category: '综艺',
    rating: 8.5,
    image: 'https://readdy.ai/api/search-image?query=vibrant%20stage%20performance%20poster%2C%20female%20performer%20on%20colorful%20stage%20with%20spotlights%2C%20variety%20show%20aesthetic%2C%20energetic%20and%20dynamic%20composition%2C%20warm%20stage%20lighting&width=600&height=800&seq=hot-rec-05&orientation=portrait',
    tag: '热播',
  },
  {
    id: 6,
    title: '鬼灭之刃 剧场版',
    category: '动漫',
    rating: 9.3,
    image: 'https://readdy.ai/api/search-image?query=anime%20movie%20poster%20style%2C%20Japanese%20animation%20character%20with%20sword%20in%20dynamic%20pose%2C%20dramatic%20fire%20and%20water%20effects%2C%20vibrant%20colors%2C%20clean%20composition%20with%20dark%20background&width=600&height=800&seq=hot-rec-06&orientation=portrait',
    tag: '推荐',
  },
];

export const latestUpdates = [
  {
    id: 7,
    title: '狂飙2：无声的较量',
    category: '电视剧',
    episode: '更新至第18集',
    updateTime: '2小时前',
    image: 'https://readdy.ai/api/search-image?query=modern%20Chinese%20crime%20drama%20scene%2C%20two%20men%20in%20tense%20confrontation%20in%20urban%20setting%2C%20dark%20atmospheric%20lighting%2C%20thriller%20aesthetic%2C%20cinematic%20composition%2C%20moody%20tones&width=600&height=400&seq=latest-01&orientation=landscape',
  },
  {
    id: 8,
    title: '长相思 第二季',
    category: '电视剧',
    episode: '更新至第32集',
    updateTime: '4小时前',
    image: 'https://readdy.ai/api/search-image?query=romantic%20Chinese%20fantasy%20drama%20scene%2C%20couple%20in%20ancient%20costumes%20in%20beautiful%20garden%20setting%2C%20soft%20warm%20lighting%2C%20ethereal%20atmosphere%2C%20cinematic%20composition&width=600&height=400&seq=latest-02&orientation=landscape',
  },
  {
    id: 9,
    title: '中国奇谭 第二季',
    category: '动漫',
    episode: '更新至第8集',
    updateTime: '6小时前',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20style%20scene%2C%20traditional%20Chinese%20art%20inspired%20fantasy%20landscape%20with%20mythical%20creatures%2C%20watercolor%20painting%20aesthetic%2C%20soft%20warm%20colors%2C%20artistic%20composition&width=600&height=400&seq=latest-03&orientation=landscape',
  },
  {
    id: 10,
    title: '舌尖上的中国 第五季',
    category: '纪录片',
    episode: '更新至第5集',
    updateTime: '8小时前',
    image: 'https://readdy.ai/api/search-image?query=delicious%20Chinese%20cuisine%20close-up%20food%20photography%2C%20steaming%20hot%20dish%20on%20wooden%20table%2C%20warm%20ambient%20lighting%2C%20documentary%20style%20food%20photography%2C%20rich%20colors%20and%20textures&width=600&height=400&seq=latest-04&orientation=landscape',
  },
  {
    id: 11,
    title: '奔跑吧 第十二季',
    category: '综艺',
    episode: '更新至2026-08-01期',
    updateTime: '12小时前',
    image: 'https://readdy.ai/api/search-image?query=outdoor%20variety%20show%20scene%2C%20group%20of%20celebrities%20running%20and%20laughing%20in%20sunny%20park%2C%20bright%20cheerful%20atmosphere%2C%20entertainment%20show%20aesthetic%2C%20vibrant%20colors&width=600&height=400&seq=latest-05&orientation=landscape',
  },
  {
    id: 12,
    title: '熊出没·重启未来',
    category: '少儿',
    episode: '更新至第45集',
    updateTime: '1天前',
    image: 'https://readdy.ai/api/search-image?query=cute%203D%20animated%20bears%20in%20colorful%20forest%20scene%2C%20children%20animation%20style%2C%20bright%20warm%20sunlight%2C%20playful%20atmosphere%2C%20family-friendly%20aesthetic&width=600&height=400&seq=latest-06&orientation=landscape',
  },
];

export const stats = [
  { label: '影视资源', value: '12,000+', icon: 'ri-film-line' },
  { label: '日更新量', value: '500+', icon: 'ri-refresh-line' },
  { label: '活跃用户', value: '800万+', icon: 'ri-user-heart-line' },
  { label: '合作平台', value: '50+', icon: 'ri-group-line' },
];